const colors = [
  'a171a7',
  'c58853',
  'dc749c',
  '9eb535',
  'cfc963',
  '6bc7d1',
  '5094c9',
  'b5d55d',
  '58d5ad',
  'e29797',
]

export const nivoDarkColors = colors.map((item) => `#${item}`)
